import React from "react";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import { useParams } from "react-router";
let privacyPolicyLink = "/Annex D Client Privacy -EN.pdf";

const ClientTermsAndConditions = ({ formik }) => {
  const { t } = useTranslation();
  const { lang } = useParams();
  
    if (lang === "it") {
      privacyPolicyLink = "/Allegato_D_Client_Privacy_IT.pdf";
    }
  

  return (
    <Form.Group className="mb-3">
      <div
        className={
          formik.touched.acceptPrivacyPolicy &&
          !!formik.errors.acceptPrivacyPolicy
            ? "is-invalid"
            : ""
        }
      >
        <Form.Check
          type="checkbox"
          className="d-flex align-items-start"
          label={
            <>
              {t("i_accept")}{" "}
              <a
                href={privacyPolicyLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "white" }}
              >
                {t("form.supplierCustomerInformation")}
              </a>
            </>
          }
          value={formik.values.acceptPrivacyPolicy}
          name="acceptPrivacyPolicy"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isInvalid={
            formik.touched.acceptPrivacyPolicy &&
            !!formik.errors.acceptPrivacyPolicy
          }
        />
      </div>
      <Form.Control.Feedback type="invalid">
        {t(`error.${formik.errors.acceptPrivacyPolicy}`)}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default ClientTermsAndConditions;
